import { MILLISECONDS_IN_MINUTE } from '@stdlib/constants-time';
import { useQuery } from '@tanstack/react-query';
import { useMemo } from 'react';

import type { BookingRefundResponse } from 'app/typings/core/admin/bookings/bookingRefund';
import { apiRequest } from 'app/utils/request/api';

import { CORE_QUERY_KEYS, ENDPOINTS } from '.';

export function useBookingRefund(
  bookingCode: string,
  refundModalVisible: boolean
) {
  const key = useMemo(
    () => [CORE_QUERY_KEYS.bookingRefund, { code: bookingCode }],
    [bookingCode]
  );

  return useQuery({
    queryKey: key,
    queryFn: () =>
      apiRequest({
        path: ENDPOINTS.getBookingRefund,
        params: { bookingCode },
      }) as Promise<BookingRefundResponse>,
    staleTime: 5 * MILLISECONDS_IN_MINUTE,
    enabled: !!refundModalVisible,
  });
}
